var $counter = $('header .main-menu .wrapper .time-wrapper');

$counter.hover(function() {
    $(this).children('.time-counter').addClass('hide');
    $(this).children('.est_date').addClass('show');
}, function() {
    $(this).children('.time-counter').removeClass('hide');
    $(this).children('.est_date').removeClass('show');
});